import { Drawer, Menu } from 'antd';
import styled from 'styled-components';

import { CloseOutlined, MenuOutlined } from '@ant-design/icons';

export const SiderContainer = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  height: 100vh;
  width: 90px;
  overflow: auto;
  background-color: white;
  padding: 0 8px;

  box-shadow: 2px 0px 8px 0px rgba(39, 111, 175, 0.15);
  -webkit-box-shadow: 2px 0px 8px 0px rgba(39, 111, 175, 0.15);
  -moz-box-shadow: 2px 0px 8px 0px rgba(39, 111, 175, 0.15);

  .ant-menu-item {
    border-radius: 6px;
    align-items: center;
    justify-content: center;
  }
`;

export const SiderLogo = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.2);
  color: white;
  margin: 0;
  height: 64px;

  @media (min-width: 576px) {
    margin: 1.1rem;
    height: 2.3rem;
  }
`;

export const MenuItem = styled(Menu.Item)`
  display: flex;

  &:hover {
    background-color: #f2f8fe !important;
  }

  &:active {
    background-color: #e9f3fd !important;
  }
`;

export const BottomMenuContainer = styled.div`
  position: absolute !important;
  bottom: 1.4rem;
  padding: 0px;
`;

export const MenuDivider = styled.div`
  height: 1px;
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 1) 0%,
    rgba(236, 236, 236, 1) 50%,
    rgba(255, 255, 255, 1) 100%
  );
`;

export const NavButton = styled.button`
  background: none;
  margin: 0;
  padding: 0;
  border: 0;
  cursor: pointer;
`;

export const BurgerIcon = styled(MenuOutlined)`
  font-size: 24px;
  margin: 0;
  background: transparent;
  box-shadow: none;
  color: rgb(34, 133, 235);
`;

export const CloseIcon = styled(CloseOutlined)`
  font-size: 24px;
  margin: 0;
  background: transparent;
  box-shadow: none;
  color: rgb(34, 133, 235);
`;

export const MenuContentHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;

  @media (min-width: 576px) {
    display: block;
    padding: 0;
  }
`;

export const MenuLinkLabel = styled.span<{ spacing?: 'small' | 'large'; selected?: boolean }>`
  font-size: 18px;
  font-weight: bold;
  margin-left: 15px;
  color: ${({ selected }) => (selected ? 'white' : 'inherit')};

  @media (min-width: 576px) {
    display: none;
  }
`;

export const StyledDrawer = styled(Drawer)`
  .ant-drawer-body {
    padding: 0;
  }
`;

export const Navbar = styled.div`
  position: fixed;
  background: white;
  width: 100%;
  height: 64px;
  top: 0;
  left: 0;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
`;

export const LogOutButtonContainer = styled.div`
  padding: 0 9px;

  @media (min-width: 576px) {
    padding: 0;
  }
`;
